import React, {useEffect, useRef, useState} from "react"
import {useSelector} from "react-redux"
import {ServiceCardType} from "../Types";
import api from "../../../Services/api";
import {ApiResponse} from "apisauce";
import MoveInProgress from "./MoveInProgress";
import MoveFailed from "./MoveFailed";
import MoveSuccess from "./MoveSuccess";
import {RootState} from '../../../Redux'

const { checkIn } = api.create();

interface MovedToWorkQueueProps {
    serviceCard: ServiceCardType;
    paymentDone?: boolean;
}

const MoveToWorkQueue = ({ serviceCard, paymentDone = false }: MovedToWorkQueueProps) => {
    const customerInfo = useSelector((state: RootState) => state.ui.customer)
    const [checkInSuccess, setCheckInSuccess] = useState<boolean>()
    const [error, setError] = useState<string|null>(null)

    const inProgress = useRef(false)

    useEffect(() => {
        if (!serviceCard?.token || inProgress.current === true) {
            return
        }
        inProgress.current = true

        async function handleCheckIn() {
            const response: ApiResponse<any> = await checkIn(serviceCard.token, {token: serviceCard.token, customerToken: customerInfo?.token});
            if (response.ok) {
                setCheckInSuccess(true)
            } else {
                setError(response?.data?.error?.message ?? null)
                setCheckInSuccess(false)
            }
        }
        handleCheckIn().then(() => {
            inProgress.current = false
        })
    }, [serviceCard?.token, customerInfo?.token]);

    return (<>
        {checkInSuccess === undefined && <MoveInProgress/>}
        {checkInSuccess === false && <MoveFailed paymentDone={paymentDone} error={error}/>}
        {checkInSuccess === true && <MoveSuccess serviceCard={serviceCard} paymentDone={paymentDone} />}
    </>)
}

export default MoveToWorkQueue
